const $ = require('../../../public/unversioned/js/jquery.min');

exports.post = function(url,data){
   return new Promise((resolve, reject) => {
      $.post( url, data, function(returnedData) {
         if(returnedData.responseType === 'error') {
            reject(returnedData.message);
         }
         else if(returnedData.responseType === 'success'){
            resolve(returnedData.data)
         }
         else {
            alert('Your session has timed out');
         }
      })
         .fail(function(msg) {
            console.log(JSON.parse(msg.responseText));
            reject(JSON.parse(msg.responseText));
         });
   });
};

exports.get = function(url, data){
   return new Promise((resolve, reject) => {
      $.get( url, data, function(returnedData) {
         if(returnedData.responseType === 'error') {
            reject(returnedData.message);
         }
         else if(returnedData.responseType === 'success'){
            resolve(returnedData.data)
         }
         else {
            alert('Your session has timed out');
            console.log('no access to ' + url);
         }
      })
         .fail(function(msg) {
            console.log(msg.responseText);
            reject(msg);
         });
   });
};

exports.upload = function(url, data, additionalData = ''){
   return new Promise((resolve, reject) => {
      let fd = new FormData();
      fd.append( 'data', data );
      fd.append( 'additionalData', additionalData);

      $.ajax({
         type: "POST",
         url,
         /*xhr: function () {
             let myXhr = $.ajaxSettings.xhr();
            if (myXhr.upload) {
               myXhr.upload.addEventListener('progress', that.progressHandling, false);
            }
            return myXhr;
         },*/
         success: function (data) {
            resolve(data);
         },
         error: function (error) {
            reject(error);
         },
         async: true,
         data: fd,
         cache: false,
         contentType: false,
         processData: false,
         timeout: 60000
      });
   });
};